import { UpdatePassword } from 'domain/usecases/user/update-password'
import { UserRepository } from 'repository/repositories/user/user-repository'

export class RemoteUpdateUserPassword implements UpdatePassword {
  private readonly userRepository: UserRepository

  constructor(userRepository: UserRepository) {
    this.userRepository = userRepository
  }

  updatePassword(params: UpdatePassword.Params): Promise<UpdatePassword.Model> {
    return this.userRepository.updatePassword(params)
  }
}
